import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import { AppThemeContext, useTheme } from './common/styling/theme';
import store from './common/config/store';

const persistor = persistStore(store);

interface Props {
  children: React.ReactNode;
}

const Root: React.FC<Props> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <AppThemeContext.Provider value={{ theme }}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            {children}
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </AppThemeContext.Provider>
  );
};

export default Root;
